module.exports = __webpack_public_path__ + "static/media/Logo.be6818ea.png";